module.exports = __webpack_public_path__ + "static/media/garry-sobars.4ea000af.jpg";